import { Component } from '@angular/core';

@Component({
  selector: 'stars-elements-resources',
  templateUrl: './elements-resources.html',
  styleUrls: ['./elements-resources.scss']
})
export class ElementsResourcesComponent {}
